/**
 * Batch-Lookup Produkt-id→Name für die Review-Anzeige (P2/T15, Fund aus T7:
 * Karten zeigten bisher nur die gekürzte `product_id`). `ids` stabil sortiert
 * für einen cache-stabilen Query-Key, deaktiviert bei leerem Array, großzügige
 * `staleTime` — Produktnamen ändern sich selten.
 */
import { useQuery } from '@tanstack/react-query'

import { getProductNames } from '@/lib/api/channel-content-bulk'

export function useProductNames(ids: string[]) {
  const sortedIds = [...new Set(ids)].sort()
  return useQuery({
    queryKey: ['textRuns', 'productNames', sortedIds],
    queryFn: () => getProductNames(sortedIds),
    enabled: sortedIds.length > 0,
    staleTime: 5 * 60 * 1000,
  })
}
